Wee.fn.make('colorWizard', {
	init: function() {
		this.$private.load();
	}
}, {
	load: function() {
		if (! Wee.wizard) {
			$.assets.load({
				root: $.get('cdnUrl'),
				js: '/assets/modules/wizard/script.min.js',
				css: '/assets/modules/wizard/style.min.css',
				success: function() {
					Wee.wizard.init();
				}
			});
		} else {
			Wee.wizard.init();
		}
	}
});